import { render } from "./ParcelaDebitoVeicular.vue?vue&type=template&id=616a88e0"
import script from "./ParcelaDebitoVeicular.vue?vue&type=script&lang=js"
export * from "./ParcelaDebitoVeicular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__